import { cn } from '../../lib/cn'

interface ChipProps {
  active?: boolean
  onClick?: () => void
  children: React.ReactNode
  count?: number
  className?: string
  accent?: string
}

export function Chip({ active = false, onClick, children, count, className, accent }: ChipProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-pressed={active}
      className={cn(
        'inline-flex items-center gap-2 rounded-full border px-4 py-2 text-sm font-medium transition-all duration-300 ease-premium focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-lime-bright',
        active
          ? 'border-transparent text-white shadow-soft'
          : 'border-sand-200 bg-white text-ink-700 hover:border-brand-400 hover:text-brand-600',
        className,
      )}
      style={active ? { background: accent ?? '#128537' } : undefined}
    >
      {children}
      {count != null && (
        <span className={cn('rounded-full px-1.5 text-xs', active ? 'bg-white/20' : 'bg-sand-100 text-ink-500')}>
          {count}
        </span>
      )}
    </button>
  )
}
